import { BaseClass } from './base'

export class UserClass extends BaseClass {
  modelRef = {
    username: '',
    password: '',
    name: '',
    sex: 0,
    birthDay: null,
    avatar: '',
    mobile: '',
    wechartName: '',
    wechartNum: '',
    roleId: null
  }

  rulesRef = {
    username: [
      {
        required: true,
        message: '请输入用户名'
      }
    ],
    password: [
      {
        required: true,
        message: '请输入密码'
      }
    ],
    name: [
      {
        required: true,
        message: '请输入姓名'
      }
    ]
  }

  // 平台登录
  login (data) {
    return this.post(this.account + '/ManageLogin', data)
  }

  reg (data) {
    return this.post(this.account + '/Reg', data)
  }

  menus () {
    return this.get(this.menu + '/GetUserRoleMenus')
  }

  userInfo () {
    return this.get(this.account + '/UserCache')
  }

  logout () {
    return this.get(this.account + '/Logout')
  }

  psw (data) {
    return this.put(this.account + '/ChangePsw', data)
  }

  gets (params) {
    return this.get(this.user, params)
  }

  create (data) {
    return this.post(this.user, data)
  }

  update (data) {
    return this.put(this.user, data)
  }

  updateSelf (data) {
    return this.put(this.user + '/Self', data)
  }

  del (id) {
    return this.delete(this.user + `/${id}`)
  }

  alinum (aliNum) {
    return this.get('/api/User/SetAliNum', { aliNum })
  }

  welfareTimes (id, count) {
    return this.get(this.user + `/SetMemberWelfareTimes/${id}/${count}`)
  }

  welfareTimes2 (count) {
    return this.get(this.user + `/SetWelfareTimes/${count}`)
  }

  state (params) {
    return this.get(this.user + `/AllowLogin/${params.id}/${params.state}`)
  }

  active (id, state) {
    return this.get(this.user + `/Active/${id}/${state}`)
  }

  setRoles (userId, roleIds) {
    return this.post(this.user + '/SetUserRole', { userId, roleIds })
  }

  setDep (userId, departmentId) {
    return this.get(`/api/User/BindDepartment/${userId}/${departmentId}`)
  }

  setEnter (userId) {
    return this.get(`/api/User/SetUserEnter/${userId}`)
  }
}

export class ActionLogClass extends BaseClass {
  gets (params) {
    return this.get('/api/ActionLog', params)
  }
}

export class BillClass extends BaseClass {
  gets (params) {
    return this.get('/api/Bill', params)
  }
}

export class WithDrawClass extends BaseClass {
  gets (params) {
    return this.get('/api/WithDraw', params)
  }

  create (money) {
    return this.post('/api/WithDraw', { money })
  }

  exportAll (params) {
    return this.export('/api/WithDraw/Exports', 'GET', params)
  }

  state (params) {
    return this.get('/api/WithDraw/BathSetWithDrawState', params)
  }
}

export class StatClass extends BaseClass {
  info () {
    return this.get('/api/Stat/StatInfo')
  }

  line () {
    return this.get('/api/Stat/StatLine')
  }

  commission (monthdate) {
    return this.get('/api/Stat/Commission', { monthdate })
  }

  sales (type, selectDate) {
    return this.get('/api/Stat/Sales', { type, selectDate })
  }

  follow () {
    return this.get('/api/Stat/Followup')
  }

  interest (type, selectDate) {
    return this.get('/api/Stat/Interest', { type, selectDate })
  }

  incomes (type, selectDate) {
    return this.get('/api/Stat/Incomes', { type, selectDate })
  }
}

export class DepartmentClass extends BaseClass {
  modelRef = {
    name: '',
    mobile: '',
    areaCode: '',
    parentId: 0,
    platformRate: 0,
    sortNum: 0
  }

  rulesRef = {
    name: [
      {
        required: true,
        message: '请输入标题'
      }
    ],
    areaCode: [
      {
        required: true,
        message: '请输入区域代码'
      }
    ]
  }

  gets () {
    return this.get('/api/Department')
  }

  create (data) {
    return this.post('/api/Department', data)
  }

  update (data) {
    return this.put('/api/Department', data)
  }

  del (id) {
    return this.delete('/api/Department' + `/${id}`)
  }

  sort (id, sort) {
    return this.get(`/api/Department/Sort/${id}/${sort}`)
  }
}

export class WechartClass extends BaseClass {
  login (code) {
    return this.get('/api/WeixinGzh/Login', { code })
  }

  regist (code) {
    return this.get('/api/WeixinGzh/Register', { code })
  }

  jsConfig (url = '') {
    if (url === '') {
      url = location.href
    }
    return this.get('/api/WeixinGzh/GetWxJSConfig', { url })
  }
}
